







































































import Vue from 'vue'
import { ShopsListItemData } from '../types'
import AppDialogPrompt from '@morpheus/utils/admin-vue/components/AppDialogPrompt.vue'

export default Vue.extend({
  name: 'ShopsList',
  components: {
    AppDialogPrompt
  },
  props: {
    headers: {
      required: true,
      type: Array as () => Array<any>
    },
    items: {
      required: true,
      type: Array as () => Array<ShopsListItemData>
    },
    totalItems: {
      required: true,
      type: Number
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      shopToCopy: '',
      copyMessage: ''
    }
  },
  methods: {
    copyShop (shopId: string) {
      this.copyMessage = 'Please, enter code name for new shop'
      this.shopToCopy = shopId
    },
    cancelCopyShop () {
      this.copyMessage = ''
      this.shopToCopy = ''
    },
    confirmCopyShop (shopCode: string) {
      this.copyMessage = ''
      this.$emit('onCopyShop', this.shopToCopy, shopCode)
    }
  }
})
